import { defineStore } from "pinia";
import Notification from "../../types/Notification/INotification";
import { v4 as uuidv4 } from "uuid";

interface State {
  notifications: Notification[];
  notificationsDisabled: boolean;
}

export const useNotificationsStore = defineStore("notifications", {
  state: (): State => ({
    notifications: [],
    notificationsDisabled: false,
  }),

  actions: {
    createNotification(notification: Notification) {
      if (!this.notificationsDisabled || notification.extarnalUse) {
        notification.id = uuidv4();
        this.notifications.push(notification);
      } else {
        const message = {
          type: "callback",
          action: "onAlert",
          data: {
            args: [notification],
          },
        };
        return window.parent.postMessage(message, "*");
      }
    },

    removeNotification(notification: Notification) {
      this.notifications = this.notifications.filter(
        (n) => n.id !== notification.id
      );
    },

    disableNotifications() {
      this.notificationsDisabled = true;
    },
  },
});
